/*
  Step Labs horizontal rail (<c-rail>): a scroll-snap track with prev/next arrows and
  optional dots. Markup contract inside the element:
    [data-track]     the scrolling list
    [data-dir="-1"]  previous arrow   [data-dir="1"] next arrow
    [data-dots]      empty container; one dot per item is created here
  Arrows get aria-disabled at the ends (the theme styles button[disabled] with !important).
*/
if (!customElements.get('c-rail')) {
  customElements.define(
    'c-rail',
    class CRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.items = [...this.track.children];
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        const dots = this.querySelector('[data-dots]');
        this.dots = [];
        if (dots && !dots.children.length) {
          this.items.forEach((item, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = dots.dataset.dotClass || 'c-rail__dot';
            dot.setAttribute('aria-label', `Go to item ${i + 1} of ${this.items.length}`);
            dot.addEventListener('click', () => this.scrollToItem(i));
            dots.appendChild(dot);
            this.dots.push(dot);
          });
        }
        [this.prev, this.next].forEach((btn) => btn && btn.addEventListener('click', () => {
          if (btn.getAttribute('aria-disabled') === 'true') return;
          this.track.scrollBy({ left: Number(btn.dataset.dir) * this.track.clientWidth * 0.6, behavior: this.behavior() });
        }));
        this.raf = 0;
        this.schedule = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); };
        this.track.addEventListener('scroll', this.schedule, { passive: true });
        this.ro = new ResizeObserver(this.schedule);
        this.ro.observe(this.track);
        this.schedule();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        cancelAnimationFrame(this.raf);
      }

      behavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      scrollToItem(i) {
        const start = this.items[0].offsetLeft;
        this.track.scrollTo({ left: this.items[i].offsetLeft - start, behavior: this.behavior() });
      }

      setArrow(btn, off) {
        if (!btn) return;
        btn.setAttribute('aria-disabled', off ? 'true' : 'false');
        btn.tabIndex = off ? -1 : 0;
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const x = this.track.scrollLeft;
        this.setArrow(this.prev, x <= 4);
        this.setArrow(this.next, max <= 4 || x >= max - 4);
        if (!this.dots.length) return;
        const start = this.items[0].offsetLeft;
        let active = 0;
        this.items.forEach((item, i) => { if (item.offsetLeft - start <= x + 10) active = i; });
        if (x >= max - 4) active = this.items.length - 1;
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === active ? 'true' : 'false'));
      }
    }
  );
}
